import router from "@/router";
import { onBeforeMount, ref, watch, reactive } from "@vue/composition-api";

export default function useDocumentInfo() {
  const modeEditor = ref(true);

  const stepActive = ref(0);

  const documentId = ref(0);

  const checkFormCreateOrEdit = () => {
    if (router.currentRoute.params.ref) {
      modeEditor.value = false;
      documentId.value = parseInt(router.currentRoute.params.ref);
    }
  };

  const onGetDocumentId = (id) => {
    documentId.value = id;
  };

  const onNextStep = () => {
    stepActive.value = stepActive.value++;
  };

  const onPreviousStep = () => {
    stepActive.value = stepActive.value--;
  };

  const formData = reactive({
    isConfirm: false,
    totalPoint: 0,
    totalSpending: 0,
    receiptNo: "",
    storeName: "",
    remark1: "",
    remark2: "",
    itfRef1: "",
    itfRef2: "",
    itfExtra: "",
    status: 1,
  });

  const onFormData = (isConfirm) => {
    formData.isConfirm = isConfirm;
  };

  const onSetFormData = (formDataObj) => {
    formData.totalPoint = formDataObj.totalPoint;
    formData.totalSpending = formDataObj.totalSpending;
    formData.receiptNo = formDataObj.receiptNo;
    formData.storeName = formDataObj.storeName;
    formData.remark1 = formDataObj.remark1;
    formData.remark2 = formDataObj.remark2;
    formData.itfRef1 = formDataObj.itfRef1;
    formData.itfRef2 = formDataObj.itfRef2;
    formData.itfExtra = formDataObj.itfExtra;
    formData.status = formDataObj.status;
  };

  onBeforeMount(() => {
    if (localStorage.getItem("activeTab") !== null) {
      stepActive.value = parseInt(localStorage.getItem("activeTab"));
    } else {
      localStorage.setItem("activeTab", stepActive.value);
    }

    checkFormCreateOrEdit();
  });

  watch(
    stepActive,
    () => {
      localStorage.setItem("activeTab", stepActive.value);
    },
    { deep: true }
  );

  return {
    modeEditor,
    stepActive,
    documentId,
    onGetDocumentId,
    onNextStep,
    onPreviousStep,
    onFormData,
    formData,
    onSetFormData,
  };
}
